<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="《阜阳侯先森商贸有限公司》品牌代理人代理协议书" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <div class="textTop">
      <div>注册协议</div>
      <div class="topCon">
        <span class="boldText">【审慎阅读】</span>您在申请平台用户流程中点击同意前，应当认真阅读以下协议。<span>请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</span>
      </div>
      <div class="topCon boldText" style=" text-decoration: underline;">
        1、与您约定免除或限制责任的条款；
      </div>
      <div class="topCon boldText" style=" text-decoration: underline;">
        2、与您约定法律适用和管辖的条款；
      </div>
      <div class="topCon boldText" style=" text-decoration: underline;">
        3、其他以粗体下划线标识的重要条款。
      </div>
      <div class="topCon">
        如您对协议有任何疑问，可向平台客服咨询。
      </div>
      <div class="topCon">
        <span
          class="boldText">【特别提示】</span>当您按照申请平台用户页面提示填写信息、阅读并同意协议且完成全部申请销售商程序后，即表示您已充分阅读、理解并接受协议的全部内容。如您因平台用户服务与阜阳侯先森商贸有限公司发生争议的，适用《阜阳侯先森商贸有限公司平台服务协议》及系列相关协议处理。如您在使用平台服务过程中与其他用户发生争议的，依您与其他用户达成的协议处理。
      </div>
      <div class="topCon boldText" style=" text-decoration: underline;">
        阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止申请销售商程序。
      </div>
    </div>
    <div class="noticeList">
      <div class="noticeItem" @click="$router.push({path:'registerDetails',query:{noticeCon:item}})"
        v-for='(item,index) in noticeList' :key='index'>
        <div class="topCon itemTitle">《{{item.title}}》</div>
      </div>
    </div>
    <div class="btmCon">
    <p class="regText">
      <van-checkbox v-model="checkeds"><span style="color: #FA4A42;">我已详细阅读并充分理解《注册协议》</span></van-checkbox>
    </p>
    <button :disabled='!checkeds'  @click="submitNext">
      同意
    </button>
  </div>
  </div>
</template>
<script>
  import {
    noticeList
  } from "@/api/login";
  export default {
    data() {
      return {
        noticeList: [],
        checkeds: false
      }
    },
    created() {
      noticeList().then(res => {
        this.noticeList = res;
      })
    },
    methods: {
      submitNext() {
        this.$router.push('register');
      }
    }
  };
</script>
<style lang='less' scoped>
  /deep/ .van-nav-bar__title{
    max-width:80%;
  }
  .wrap {
    font-size: 13px;
    padding-bottom:100px;
    .textTop {
      width: 100%;
      padding: 10px 10px 0 10px;
      box-sizing: border-box;
    }

    .topCon {
      text-indent: 30px;
      line-height: 30px;
    }

    .noticeList {
      .noticeItem {
        width: 345px;
        font-size: 14px;

        .itemTitle {
          font-size: 14px;
          margin-bottom: 5px;
          color: #3B6BFB;
        }

      }
    }
  }

  /deep/.van-nav-bar__title {
    font-size: 0.22667rem;
  }

  .boldText {
    font-weight: bold;
  }

  .regText {
    margin: 20px auto;
    color: #FA4A42;
    font-size: 14px;
    width: 300px;

    .van-checkbox {
      text-align: center;

    }

    margin:0 auto;
  }

  button {
    width: 350px;
    display: block;
    margin: 10px auto;
    height: 42px;
    font-size:14px;
    line-height: 42px;
    border-radius: 21px;
    border: 0 none;
    background: #3B6BFB;
    color: #fff;
  }

  button:disabled {
    background: #f5f5f5;
    color: #666;
  }
  .btmCon{
    width:100%;
    background: #fff;
    position: fixed;
    z-index: 10;
    bottom:0;
    left:50%;
    transform: translateX(-50%);
  }
</style>